import { render, staticRenderFns } from "./SealManagementDetail.vue?vue&type=template&id=b54cf5b6&scoped=true"
import script from "./SealManagementDetail.vue?vue&type=script&lang=js"
export * from "./SealManagementDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54cf5b6",
  null
  
)

export default component.exports